__turbopack_context__.v({
  "className": "inter_7b1668c-module__Vej2Fa__className",
  "variable": "inter_7b1668c-module__Vej2Fa__variable",
});
